// @ts-nocheck
/* eslint-disable */
export const arrowForwardIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M686-450H160v-60h526L438-758l42-42 320 320-320 320-42-42 248-248Z"/></svg>`,
    name: 'arrow-forward' as const
};